import React from "react";
import { Slide } from "react-reveal";
import Mission from "../reusables/Mission";

const AboutBody = () => {
  return (
    <section className="section section-spacing-50 no-padding-bottom cloudy-bg">
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="textpage-container">
              <div className="textpage-inner section-spacing-50 no-padding-top flex">
                <div className="textpage-text-side">
                  <h2 className=" light-blue">JMSTONE LOGISTICS LIMITED</h2>
                  <div className="textpage-text-body">
                    <p>
                      Founded in 2021, JMSTONE LOGISTICS LIMITED is fully
                      registered by the registrar of companies of the Republic
                      of Uganda, under company number{" "}
                      <strong>8002003428526</strong>. Qualified on the National
                      Supplier Database with number,{" "}
                      <strong>NS15526/2024/4506</strong>.
                    </p>
                    <p>
                      Our journey began with individual expertise and experience
                      in various Engineering fields of Civil Engineering,
                      Mechanical Engineering, Electrical Engineering, and
                      building construction.
                    </p>
                    <p>
                      After the many years of individual engagement of the
                      founders in rendering such services until they decided to
                      incoporate and execute clients' works as a company. This
                      evolved into a collective vision to offer comprehensive
                      services positioning JMSTONE excels as a leading installer
                      of geosynthetic products and HDPE pipes in Uganda,
                      particularly in the oil and gas sector.{" "}
                    </p>
                    <p>
                      Our competitiveness is derived from our deep understanding
                      of our customers’ needs and our non –compromising stand on
                      delivering quality products and services, in a safe and
                      environmentally conscious approach.
                    </p>
                    <p>
                      Our commitment to innovation and excellence invariably
                      results in a successfully completed projects for both
                      contractors and clients. We understand and promote the
                      idea of working in a partnership with our clients to
                      ensure their goals are met.
                    </p>
                    <h3>Our Vision</h3>
                    <p>
                      “To be the leading geosynthetics solutions provider in
                      Uganda and East Africa, driving infrastructure innovation,
                      and environmental sustainability.”
                    </p>
                    <h3>Our Mission</h3>
                    <p>
                      “JMSTONE LOGISTICS LIMITED, aims to deliver superior
                      engineering and geosynthetic installation services with
                      unwavering dedication to quality, safety, and
                      environmental responsibility”
                    </p>

                    <h3>Our Core Values</h3>
                    <ul>
                      <li>
                        <strong>Environmental stewardship:</strong> We
                        prioritize the protection and conservation of the
                        environment and natural resources.
                      </li>
                      <li>
                        <strong> Innovation:</strong> We embrace creativity,
                        innovation, and technological advancement to deliver
                        cutting-edge solutions.
                      </li>
                      <li>
                        <strong> Customer centricity: </strong> We design our
                        solutions to promote sustainable development and
                        minimize environmental footprint of projects where we
                        work.
                      </li>
                      <li>
                        <strong> Collaboration. : </strong> We foster a culture
                        of collaboration, team work and open communication to
                        achieve common goals.
                      </li>
                      <li>
                        <strong> Integrity: </strong> We operate our business
                        with transparency, honesty, and ethical business
                        practices, maintaining the highest level of integrity in
                        all our interactions.
                      </li>
                      <li>
                        <strong> Accountability: </strong> We take
                        responsibility of our actions, decisions, and outcomes,
                        continually learning and improving.
                      </li>
                    </ul>

                    <h3>Our Location &amp; Contacts</h3>
                    <p>
                      We are located in Nantabulirwa, Goma Division, Mukono
                      District, Uganda. You can always give us a call or
                      WhastApp on +256 (770) 882 236 or send us an email
                      info@jmstonelogistics.com.
                    </p>
                  </div>
                </div>
                <Mission />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBody;
